module.exports = __webpack_public_path__ + "media/icons/arrow-30313ee2.png";